import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal } from 'antd';
import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import moment from 'moment';
import { useSalvarParametrizacao } from '../../../services/repository/parametrizacaoRepository';

function ModalCriarParametrizacao({ folha, competencia, onCloseModal, onCreatedParam, onEditParam }) {
  const [emailFacilitador, setEmailFacilitador] = useState();
  const { salvarParametrizacao, loading, error, success } = useSalvarParametrizacao();

  const displayCreateModal = !success && !error;
  const displaySuccessModal = success;
  const displayErrorModal = error && true;

  /**
   * @TODO: Melhoria para o futuro:
   * Criar um hook com a estrutura da parametrização, que já retornar os valores default
   * e utilizar tanto aqui, como na tela da parametrização.
   * Criar métodos específicos para atualizar o estado
   */
  const param = {
    id: 0,
    nome: folha.descricao,
    id_folha: folha.idFolha,
    email_alerta: emailFacilitador,
    email_alerta_adm: process.env.REACT_APP_EMAIL_ALERTA_ADM_PARAM_AUTOMATICA,
    vigencia: competencia,
    mes_vigencia: competencia.format('MM'),
    ano_vigencia: competencia.format('YYYY'),
    base_hora: 168,
    atual_comp_ap: true,
    atual_comp_ap_qtd_dias: 15,
    apresentar_coop_afast: true,
    apresentar_coop_afast_competencias: 2,
    bloquear_coop_sem_contrato: true,
    ga_should_sync_earning_values: false,
  };

  useEffect(() => {
    if (success) {
      onCreatedParam(param);
    }
  }, [success]);

  return (
    <>
      <Modal
        title="Criar Parametrização Automática"
        okText="Criar"
        okButtonProps={{ disabled: !emailFacilitador }}
        cancelText="Cancelar"
        onOk={() => salvarParametrizacao(param)}
        onCancel={onCloseModal}
        confirmLoading={loading}
        visible={displayCreateModal}
      >
        <p>
          Para criar uma parametrização de forma automática, será necessário a inserção de pelo menos um email de
          Facilitador, sendo assim uma nova parametrização será criada de forma automática e com dados padrões do
          sistema. Para criar uma parametrização manual,{' '}
          <a href={`/apontamento/parametrizar?folha=${folha.idFolha}&vigencia=${competencia.format('YYYY-MM')}`}>
            clique aqui
          </a>
          .
        </p>
        <Label label="Email para alertar o facilitador">
          <Input
            type="text"
            value={emailFacilitador}
            onChange={(e) => setEmailFacilitador(e.target.value)}
            placeholder="contato@email.com.br"
          />
        </Label>
      </Modal>

      <Modal
        title="Parametrização Falhou"
        visible={displayErrorModal}
        cancelText="Fechar"
        onOk={onCloseModal}
        onCancel={onCloseModal}
      >
        <p>Não foi possível criar uma nova parametrização.</p>
        <p>
          Durante o processo de criação automática, encontramos os seguintes problemas:
          <ul>
            <li>{error}</li>
          </ul>
        </p>
      </Modal>

      <Modal
        title="Parametrização Criada com Sucesso"
        visible={displaySuccessModal}
        cancelText="Editar"
        onOk={onCloseModal}
        onCancel={onEditParam}
        closable={false}
      >
        <p>Uma nova parametrização foi criada com sucesso.</p>
        <p>
          Dados criados automaticamente:
          <ul>
            <li>Nome da Tomadora: {param.nome}</li>
            <li>Base de horas: {param.base_hora}</li>
            <li>
              Atualização da Competência no Apontamento:&nbsp;
              {param.atual_comp_ap ? `Sim (dia ${param.atual_comp_ap_qtd_dias})` : 'Não'}
            </li>
            <li>
              Apresentar Cooperados Afastados:&nbsp;
              {param.apresentar_coop_afast ? `Sim (${param.apresentar_coop_afast_competencias} competências)` : 'Não'}
            </li>
            <li>Data de Vigência: {`${param.mes_vigencia}/${param.ano_vigencia}`}</li>
            <li>E-mails para alerta ao Administrador:</li>
            <ul>
              {param.email_alerta_adm.split(';').map((email) => (
                <li>{email}</li>
              ))}
            </ul>
          </ul>
        </p>
      </Modal>
    </>
  );
}

ModalCriarParametrizacao.propTypes = {
  folha: PropTypes.shape().isRequired,
  competencia: PropTypes.instanceOf(moment).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onCreatedParam: PropTypes.func.isRequired,
  onEditParam: PropTypes.func.isRequired,
};

export default ModalCriarParametrizacao;
